import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, Output, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { endOfDay } from 'date-fns';
import { Subject } from 'rxjs';
import { TabConst } from 'src/app/tabms/tab-consts';

@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrl: './range-date-picker.component.scss',
  providers: [DatePipe]
})
export class RangeDatePickerComponent {
  startDate: string = ''
  endDate: string = ''
  dateRange: FormGroup
  @Input() criteria: boolean = false
  @Input() reset: boolean = false
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control
  
  @Output() selectedRangeDate = new EventEmitter<{ startDate: string, endDate: string }>()

  constructor(private datePipe: DatePipe, private cdr: ChangeDetectorRef, private fb: FormBuilder) { }

  ngOnChanges() {
    if (this.reset) {
      this.dateRange.reset()
      // this.cdr.detectChanges()
    }
  }

  ngOnInit() {
    //get current date
    if (!this.criteria) {
      const today = new Date();
      this.startDate = new Date(today.getFullYear(), today.getMonth(), 1).toLocaleDateString('en-CA');
      this.endDate = today.toISOString().split('T')[0];
    }
    else {
      this.startDate = ''
      this.endDate = ''
    }

    this.dateRange = this.fb.group({
      startDate: new FormControl(this.startDate),
      endDate: new FormControl(this.endDate)
    })
  }


  getStartDate(date) {
    this.endDate = ''
    if (date) {
      // console.log('start date', date)
      // console.log(this.datePipe.transform(date, 'dd/MM/yyyy'))
      this.startDate = this.datePipe.transform(date, 'dd/MM/yyyy')
    }
  }


  getEndDate(date) {
    if (date) {
      // console.log('end date', date)
      // console.log(this.datePipe.transform(date, 'dd/MM/yyyy'))
      this.endDate = this.datePipe.transform(date, 'dd/MM/yyyy')
    }

    this.selectedRangeDate.emit({ startDate: this.startDate, endDate: this.endDate });
  }
}
